define("shared/utils/constants/linkinbio-block-route-name", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  var LinkinbioBlockRouteName = /*#__PURE__*/function (LinkinbioBlockRouteName) {
    LinkinbioBlockRouteName["EmailCollection"] = "email_collection";
    return LinkinbioBlockRouteName;
  }(LinkinbioBlockRouteName || {});
  var _default = _exports.default = LinkinbioBlockRouteName;
});